import React from 'react';
import OmCircularProgress from '../ui/OmCircularProgress';

function UserListSkeleton() {
  return (
    <div className="p-8">
      {/* Simplified Loading State */}
      <div className="flex flex-col items-center justify-center py-16">
        <div className="mb-6">
          <OmCircularProgress 
            indeterminate={true} 
            size="large"
            className="text-fresh-leaf"
          />
        </div>
        <h3 className="text-lg font-display font-medium text-deep-jungle mb-2">
          Loading Users
        </h3>
        <p className="text-steel text-sm">
          Please wait while we fetch the user data...
        </p>
      </div>
      
      {/* Simple Content Placeholder */}
      <div className="space-y-6">
        {/* Header placeholder */}
        <div className="flex justify-between items-center">
          <div className="h-8 w-48 bg-silver-mist rounded-lg animate-pulse"></div>
          <div className="h-10 w-32 bg-silver-mist rounded-lg animate-pulse"></div>
        </div>
        
        {/* Table placeholder */}
        <div className="bg-crystal-white rounded-lg border border-silver-mist/20 overflow-hidden">
          <div className="p-6 border-b border-silver-mist/20">
            <div className="h-6 w-24 bg-silver-mist rounded animate-pulse"></div>
          </div>
          <div className="divide-y divide-silver-mist/20">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="p-6">
                <div className="flex items-center space-x-4">
                  <div className="h-10 w-10 bg-silver-mist rounded-full animate-pulse"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 w-32 bg-silver-mist rounded animate-pulse"></div>
                    <div className="h-3 w-48 bg-silver-mist rounded animate-pulse"></div>
                  </div>
                  <div className="h-6 w-16 bg-silver-mist rounded animate-pulse"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserListSkeleton;
